module.exports = __webpack_public_path__ + "img/20200515-3.ef47dcf7.jpg";